import React from 'react';

export const OTP = {
  AWAITING_RESPONSE: (
    <>
      Awaiting Transaction Response.
      <br />
      Please don't close or refresh the browser.
    </>
  ),
  OTP_SENT_SUCCESS: 'OTP has been sent successfully.',
  DIGIT_CODE: (digits = 6) => digits + '-digit code',
  ENTER_CODE: (mobileNo) =>
    `Please enter the code we've sent to ${mobileNo || 'mobile number'}`,
  BTN: 'Submit',
};
